import classNames from 'classnames';
import { HotelRating as HotelRatingType } from '../../../../types/HotelFromApi';
import Star from '../../common/Icons/Star';
import testIds from '../ReviewAndAccess/testIds';
import tailwindConfig from '../../../../tailwind.config';

type Props = {
  className?: string;
  hotelRating?: HotelRatingType;
  fontClassName?: string;
};

const HotelRating = (props: Props) => {
  const { hotelRating } = props;

  const numOfStars = Math.floor(hotelRating?.averageRating || 0);

  return hotelRating ? (
    <div
      className={classNames('flex gap-2 items-center', props.className)}
      data-testid={testIds.hotel_average_rating}
    >
      <div
        className={classNames('rounded bg-teal-600 px-2 font-bold text-white', props.fontClassName)}
      >
        {hotelRating?.averageRating.toFixed(1)}
      </div>
      <div className="flex">
        {Array.from({ length: 5 }).map((_, index) => (
          <Star
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            fill={
              index < numOfStars ? undefined : tailwindConfig.theme.colors.disabled['on-disabled']
            }
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default HotelRating;
